import { render, staticRenderFns } from "./EventSideMenu.vue?vue&type=template&id=cb0f84b6&scoped=true"
import script from "./EventSideMenu.vue?vue&type=script&lang=ts"
export * from "./EventSideMenu.vue?vue&type=script&lang=ts"
import style0 from "./EventSideMenu.vue?vue&type=style&index=0&id=cb0f84b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0f84b6",
  null
  
)

export default component.exports